// extracted by mini-css-extract-plugin
module.exports = {"root":"CloseButton_root__ew1Di"};